export default "<div [@showConnectionError]=\"state\" [style.paddingLeft.px]=\"sidenavWidth\">\n    <p translate>no internet warning</p>\n</div>"